import { MainLayout } from "@/modules/main/MainLayout.tsx";
import { MobileLayout } from "@/modules/main/mobile/MobileLayout.tsx";
import { isMobileDevice } from "@/modules/main/mobile/isMobile.ts";
import type { ReactNode } from "react";

/** Renders its children in the mobile layout if the device is mobile, otherwise in the regular main layout */
export function MobileLayoutSwitch({ children }: { children: ReactNode }) {
    return isMobileDevice ? <MobileLayout>{children}</MobileLayout> : <MainLayout>{children}</MainLayout>;
}
